<template>
  <el-date-picker
    type="daterange"
    format="yyyy-MM-dd"
    :value="value"
    :picker-options="pickerOptions"
    @input="handleInput"
    @change="handleChange"
    @blur="resetPickedDate"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { isAnalyticsDateSelectable } from '@/common/utils/analytics_period'

interface Props {
  value?: (string | Date)[] | null
  campaignStartDatetime?: string | Date | null
  campaignEndDatetime?: string | Date | null
}

const props = defineProps<Props>()
const emit = defineEmits<{
  (e: 'input', value: Date[] | null): void
  (e: 'change', value: Date[] | null): void
}>()

type PickedRange = {
  minDate: Date | null
  maxDate: Date | null
}

const pickedDate = ref<Date | null>(null)

const isDisabledDate = (date: Date) => {
  // ダイアログはキャンペーン取得前と閉じた後も描画されたままのため
  if (!props.campaignStartDatetime || !props.campaignEndDatetime) {
    return false
  }

  const isSelectable = isAnalyticsDateSelectable(
    date,
    props.campaignStartDatetime,
    props.campaignEndDatetime,
    pickedDate.value
  )

  return !isSelectable
}

const handlePick = ({ minDate, maxDate }: PickedRange) => {
  const isOneSidePicked = !maxDate

  if (isOneSidePicked) {
    pickedDate.value = minDate
    return
  }

  pickedDate.value = null
}

const pickerOptions = {
  disabledDate: isDisabledDate,
  onPick: handlePick
}

const handleInput = (value: Date[] | null) => emit('input', value)
const handleChange = (value: Date[] | null) => emit('change', value)

// 片側だけ選んで閉じたとき、次に開いた際に古い選択で日付が選べなくならないようにするため
const resetPickedDate = () => {
  pickedDate.value = null
}
</script>
